// Vendor Libraries
import React, {Component} from 'react';

// Components
import Permissions from '../core/permissions';
import SearchRecordDetails from '../app/search-record-details';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'auditDetail';

class AuditDetail extends Component {
    getSearchRecordDetailProps() {
        return {
            ...this.props,
            blacklistKeys: ['version'],
            keyOrder: 'audits',
        };
    }

    render() {
        return (
            <Permissions>
                <div className="audits-detail">
                    <SearchRecordDetails {...this.getSearchRecordDetailProps()} />
                </div>
            </Permissions>
        );
    }
}

export default withSearch(AuditDetail, servicesDataKey);
